import { OnInit, EventEmitter, OnDestroy, ElementRef, OnChanges, SimpleChanges, QueryList } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatOption } from '@angular/material';
import { fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';
var BinCheckComponent = /** @class */ (function () {
    function BinCheckComponent(formBuilder) {
        this.showButton = true;
        this.emitOnSelectionChange = false;
        this.displayOption = 'Bin';
        this.noBinError = false;
        this.alternativeBinError = false;
        this.selected = new EventEmitter();
        this.binSearch = new EventEmitter();
        this.reset = new EventEmitter();
        this.clearNoBinError = new EventEmitter();
        this.clearAlternativeBinError = new EventEmitter();
        this.createForm(formBuilder);
    }
    Object.defineProperty(BinCheckComponent.prototype, "binNumberControl", {
        get: function () {
            return this.form.get('binNumber');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BinCheckComponent.prototype, "cardTypeControl", {
        get: function () {
            return this.form.get('cardType');
        },
        enumerable: true,
        configurable: true
    });
    BinCheckComponent.prototype.ngOnInit = function () {
        var _this = this;
        fromEvent(window, 'message')
            .pipe(filter(function (p) { return p.origin === window.location.origin
            && (p.data != null)
            && p.data.action === 'click'; }), map(function (p) { return p.data; }), untilDestroyed(this))
            .subscribe(function (p) {
            if (p.data === 'select') {
                _this.selectCard();
            }
            else if (p.data === 'reset') {
                _this.resetDisplay();
            }
        });
    };
    BinCheckComponent.prototype.ngOnDestroy = function () { };
    BinCheckComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.displayOption != null && changes.displayOption.currentValue === 'Card') {
            setTimeout(function () {
                if (_this.cardInputRef) {
                    _this.cardInputRef.nativeElement.focus();
                }
            }, 500);
        }
    };
    BinCheckComponent.prototype.onDropdown = function (isOpen) {
        if (isOpen && this.matOptions != null && this.matOptions.length > 0) {
            this.matOptions.first.setInactiveStyles();
        }
    };
    BinCheckComponent.prototype.createForm = function (formBuilder) {
        this.form = formBuilder.group({
            binNumber: [
                this.currentBin,
                [
                    Validators.required,
                    Validators.pattern('^[0-9]*$'),
                    Validators.maxLength(6),
                    Validators.minLength(6),
                    this.binValid.bind(this)
                ]
            ],
            cardType: [null, Validators.required]
        });
    };
    BinCheckComponent.prototype.binValid = function () {
        return this.alternativeBinError ? { 'alternative-bin': true } : (this.noBinError ? { 'no-bin': true } : null);
    };
    BinCheckComponent.prototype.binCheck = function () {
        this.binNumberControl.markAsTouched();
        if (this.binNumberControl.valid) {
            this.binSearch.emit(this.binNumberControl.value);
        }
    };
    BinCheckComponent.prototype.clearBin = function () {
        this.binNumberControl.reset(null);
        this.noBinError = false;
        this.alternativeBinError = false;
        this.binNumberControl.updateValueAndValidity();
        this.reset.emit();
    };
    BinCheckComponent.prototype.onKeydown = function () {
        if (this.noBinError) {
            this.clearNoBinError.emit();
        }
        if (this.alternativeBinError) {
            this.clearAlternativeBinError.emit();
        }
        this.noBinError = false;
        this.alternativeBinError = false;
    };
    BinCheckComponent.prototype.resetDisplay = function () {
        this.reset.emit();
        this.form.reset();
    };
    BinCheckComponent.prototype.selectCard = function () {
        // Need to show all cards here.
        this.form.get('binNumber').setValue(null);
        this.binSearch.emit('');
    };
    BinCheckComponent.prototype.submit = function () {
        this.selected.emit(this.form.value);
    };
    BinCheckComponent.prototype.onSelectionChanged = function (args) {
        if (this.emitOnSelectionChange && args.value != null) {
            this.selected.emit(this.form.value);
        }
    };
    return BinCheckComponent;
}());
export { BinCheckComponent };
